import { TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import React, { useCallback } from "react";
import AddFromDatabase from "./AddFromDatabase";
import { IntermediatePlaceholder, SinglePlaceholderPrefillProps as Props } from "./interfaces";
import { Label, SinglePlaceholderContainer } from "./styles";
import { DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES } from "../../../../utils/constants/document-template-placeholder-field-types";

const SinglePlaceholderPrefill = ({ placeholder, handleUpdatePlaceholders, dependentPlaceholders }: Props) => {
  const prehandleUpdatePlaceholder = useCallback(
    (value: string) => {
      const updatedPlaceholder: IntermediatePlaceholder = {
        ...placeholder,
        prefilledPlaceholder: {
          ...placeholder.prefilledPlaceholder,
          value,
        },
      };

      handleUpdatePlaceholders([updatedPlaceholder]);
    },
    [placeholder, handleUpdatePlaceholders]
  );

  const renderField = useCallback(() => {
    switch (placeholder.originalPlaceholder.fieldType) {
      case DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES.LegalEntity.id: {
        return (
          <>
            <TextField
              value={placeholder.prefilledPlaceholder.value}
              onChange={({ currentTarget: { value } }) => prehandleUpdatePlaceholder(value)}
              placeholder="Enter legal entity name"
            />
            <AddFromDatabase
              placeholder={placeholder}
              handleUpdatePlaceholders={handleUpdatePlaceholders}
              dependentPlaceholders={dependentPlaceholders}
            />
          </>
        );
      }
      case DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES.Employee.id: {
        return (
          <>
            <TextField
              value={placeholder.prefilledPlaceholder.value}
              onChange={({ currentTarget: { value } }) => prehandleUpdatePlaceholder(value)}
              placeholder="Enter employee name"
            />
            <AddFromDatabase
              placeholder={placeholder}
              handleUpdatePlaceholders={handleUpdatePlaceholders}
              dependentPlaceholders={dependentPlaceholders}
            />
          </>
        );
      }
      case DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES.FreeText.id: {
        return (
          <>
            <TextField
              value={placeholder.prefilledPlaceholder.value}
              onChange={({ currentTarget: { value } }) => prehandleUpdatePlaceholder(value)}
              placeholder="Enter value"
            />
          </>
        );
      }
      case DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES.Amount.id: {
        return (
          <>
            <TextField
              type="number"
              value={placeholder.prefilledPlaceholder.value}
              onChange={({ currentTarget: { value } }) => prehandleUpdatePlaceholder(value)}
              placeholder="Enter amount"
            />
          </>
        );
      }
      case DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES.Date.id: {
        return (
          <>
            <DesktopDatePicker
              onChange={(value) => {
                prehandleUpdatePlaceholder(value?.toDateString() ?? "");
              }}
              renderInput={(params) => <TextField {...params} />}
              inputFormat="dd.MM.yyyy"
              value={new Date(placeholder.prefilledPlaceholder.value)}
            />
          </>
        );
      }
      default: {
        return (
          <>
            <TextField
              value={placeholder.prefilledPlaceholder.value}
              onChange={({ currentTarget: { value } }) => prehandleUpdatePlaceholder(value)}
              placeholder="Enter value"
            />
          </>
        );
      }
    }
  }, [dependentPlaceholders, handleUpdatePlaceholders, placeholder, prehandleUpdatePlaceholder]);

  return (
    <>
      <SinglePlaceholderContainer>
        <Label>{placeholder.originalPlaceholder.name}</Label>
        {renderField()}
      </SinglePlaceholderContainer>
    </>
  );
};

export default SinglePlaceholderPrefill;
